__turbopack_context__.v({
  "collection": "ar_hvG_collection",
  "collection-add": "ar_hvG_collection-add",
  "collection-container": "ar_hvG_collection-container",
  "collection-content": "ar_hvG_collection-content",
  "collection-images": "ar_hvG_collection-images",
  "wishlist-no-items": "ar_hvG_wishlist-no-items",
});
